import { useState } from "react";
import CopyCode from "../CopyCode/CopyCode";
import Icon from "../Icon";

const BadgeComponent = () => {
	const [hoveredBadge, setHoveredBadge] = useState(null);

	return (
		<div className="flex flex-col gap-y-10 p-6">
			{/* SECTION 1: COLOR BADGES */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-white mb-6">Color Badges</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 1: Cyan */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Cyan Badges</label>
						<div className="flex flex-wrap gap-3">
						<span className="px-3 py-1 bg-amber-500 text-slate-900 font-semibold rounded-full text-sm">New</span>
						<span className="px-3 py-1 bg-amber-400 text-slate-900 font-semibold rounded-full text-sm">Featured</span>
						<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm">Live</span>
						</div>
							<CopyCode number_code={1} code={`<span className="px-3 py-1 bg-amber-500 text-slate-900 font-semibold rounded-full text-sm">
  New
</span>`} />
					</div>

					{/* Variation 2: Purple */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Purple Badges</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-amber-500 text-white font-semibold rounded-full text-sm">Pro</span>
							<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm">Premium</span>
							<span className="px-3 py-1 bg-amber-400 text-slate-900 rounded-full text-sm">Special</span>
						</div>
						<CopyCode number_code={2} code={`<span className="px-3 py-1 bg-amber-500 text-white font-semibold rounded-full text-sm">
  Pro
</span>`} />
					</div>

					{/* Variation 3: Status Colors */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Status Colors</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-green-900/40 text-green-300 border border-green-600/50 rounded-full text-sm font-medium inline-flex items-center gap-1"><Icon name="check" className="w-4 h-4" /> Active</span>
							<span className="px-3 py-1 bg-amber-900/40 text-amber-300 border border-amber-600/50 rounded-full text-sm font-medium inline-flex items-center gap-1"><Icon name="clock" className="w-4 h-4" /> Pending</span>
							<span className="px-3 py-1 bg-red-900/40 text-red-300 border border-red-600/50 rounded-full text-sm font-medium inline-flex items-center gap-1"><Icon name="close" className="w-4 h-4" /> Inactive</span>
						</div>
						<CopyCode number_code={3} code={`<span className="px-3 py-1 bg-green-900/40 text-green-300 border border-green-600/50 rounded-full text-sm">
	Active
</span>`} />
					</div>

					{/* Variation 4: Gradient Badges */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Gradient Badges</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full text-sm font-semibold">Trending</span>
							<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-amber-500 text-white rounded-full text-sm font-semibold">Hot</span>
							<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-red-500 text-white rounded-full text-sm font-semibold">Alert</span>
						</div>
							<CopyCode number_code={4} code={`<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full text-sm font-semibold">
  Trending
</span>`} />
					</div>

					{/* Variation 5: With Icons */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">With Icons</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-1">
								<span>N</span> Update
							</span>
							<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-1">
								<Icon name="star" className="w-4 h-4" /> Favorite
							</span>
							<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-1">
								<Icon name="gift" className="w-4 h-4" /> Gift
							</span>
						</div>
							<CopyCode number_code={5} code={`<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-1">
  <span>N</span> Update
</span>`} />
					</div>

					{/* Variation 6: Outline Badges */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Outline Badges</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-semibold">Outline</span>
							<span className="px-3 py-1 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-semibold">Badge</span>
							<span className="px-3 py-1 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-semibold">Style</span>
						</div>
							<CopyCode number_code={6} code={`<span className="px-3 py-1 border-2 border-amber-400 text-amber-400 rounded-full text-sm font-semibold">
  Outline
</span>`} />
					</div>

				</div>
			</div>

			{/* SECTION 2: BADGE VARIANTS & STYLES */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-amber-400 mb-6 flex items-center gap-2"><Icon name="sparkles" className="w-5 h-5" /> Badge Variants</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 7: Different Sizes */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Size Variations</label>
						<div className="flex flex-wrap gap-3 items-center">
							<span className="px-2 py-0.5 bg-amber-600 text-white rounded-full text-xs font-semibold">XS</span>
							<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm font-semibold">Small</span>
							<span className="px-4 py-1 bg-amber-600 text-white rounded-full text-base font-semibold">Medium</span>
							<span className="px-5 py-2 bg-amber-600 text-white rounded-full text-lg font-semibold">Large</span>
						</div>
						<CopyCode number_code={7} code={`<!-- XS Size -->
<span className="px-2 py-0.5 bg-amber-600 text-white rounded-full text-xs">XS</span>

<!-- Small Size -->
<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm">Small</span>

<!-- Medium Size -->
<span className="px-4 py-1 bg-amber-600 text-white rounded-full text-base">Medium</span>`} />
					</div>

					{/* Variation 8: Squircle Badges */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Rounded Variants</label>
						<div className="flex flex-wrap gap-3 items-center">
							<span className="px-3 py-1 bg-amber-600 text-white rounded text-sm">Rounded</span>
							<span className="px-3 py-1 bg-amber-600 text-white rounded-lg text-sm">More</span>
							<span className="px-3 py-1 bg-amber-600 text-white rounded-2xl text-sm">Extra</span>
							<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm">Full</span>
						</div>
						<CopyCode number_code={8} code={`<span className="px-3 py-1 bg-amber-600 text-white rounded text-sm">Rounded</span>
<span className="px-3 py-1 bg-amber-600 text-white rounded-lg text-sm">More</span>
<span className="px-3 py-1 bg-amber-600 text-white rounded-2xl text-sm">Extra</span>
<span className="px-3 py-1 bg-amber-600 text-white rounded-full text-sm">Full</span>`} />
					</div>

					{/* Variation 9: Badge with Close */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Dismissible Badges</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-2">
								Tag 1
								<button className="hover:text-amber-400 font-bold"><Icon name="close" className="w-4 h-4" /></button>
							</span>
							<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-2">
								Tag 2
								<button className="hover:text-amber-400 font-bold"><Icon name="close" className="w-4 h-4" /></button>
							</span>
						</div>
						<CopyCode number_code={9} code={`<span className="px-3 py-1 bg-amber-500/20 text-amber-300 border border-amber-500/50 rounded-full text-sm flex items-center gap-2">
  Tag
	<button className="hover:text-amber-400 font-bold">Close</button>
</span>`} />
					</div>

					{/* Variation 10: Badge Counter */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Count Badges</label>
						<div className="flex flex-wrap gap-3">
							<div className="relative inline-block">
								<span className="text-slate-300 inline-flex items-center gap-1"><Icon name="mail" className="w-4 h-4" /> Messages</span>
								<span className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-xs font-bold">5</span>
							</div>
							<div className="relative inline-block">
								<span className="text-slate-300 inline-flex items-center gap-1"><Icon name="bell" className="w-4 h-4" /> Notifications</span>
								<span className="absolute -top-2 -right-2 w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">12</span>
							</div>
						</div>
						<CopyCode number_code={10} code={`<div className="relative inline-block">
	<span>Messages</span>
  <span className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
    5
  </span>
</div>`} />
					</div>

					{/* Variation 11: Animated Badges */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Animated Badges</label>
						<div className="flex flex-wrap gap-3">
							<span className="px-3 py-1 bg-amber-500 text-slate-900 rounded-full text-sm font-semibold animate-pulse">Pulse</span>
							<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-amber-500 text-white rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-amber-500/50 transition-all">Glow</span>
							<span className="px-3 py-1 bg-amber-500 text-white rounded-full text-sm font-semibold hover:scale-110 transition-transform">Hover</span>
						</div>
						<CopyCode number_code={11} code={`<span className="px-3 py-1 bg-amber-500 text-slate-900 rounded-full text-sm font-semibold animate-pulse">
  Pulse
</span>

<span className="px-3 py-1 bg-gradient-to-r from-amber-500 to-amber-500 text-white rounded-full text-sm font-semibold hover:shadow-lg hover:shadow-amber-500/50 transition-all">
  Glow
</span>`} />
					</div>

					{/* Variation 12: Combination Badges */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Combination Styles</label>
						<div className="flex flex-col gap-3">
							<div className="flex gap-2">
								<span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">New</span>
								<span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">Pro</span>
								<span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">Hot</span>
							</div>
							<div className="flex gap-2">
								<span className="px-3 py-1 bg-slate-700 text-amber-300 border border-amber-500/50 rounded">Feature</span>
								<span className="px-3 py-1 bg-slate-700 text-amber-300 border border-amber-500/50 rounded">Update</span>
							</div>
						</div>
						<CopyCode number_code={12} code={`<!-- Multiple badges -->
<div className="flex gap-2">
  <span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">New</span>
  <span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">Pro</span>
  <span className="px-2 py-1 bg-amber-600 text-white text-xs rounded">Hot</span>
</div>`} />
					</div>

				</div>
			</div>
		</div>
	);
};

export default BadgeComponent;



